import { Tooltip } from 'react-tooltip';
import styled from 'styled-components';
import 'react-tooltip/dist/react-tooltip.css';

export const StyledTooltip = styled(Tooltip)`
  box-shadow: 0px 3.51464px 16px rgba(0, 8, 65, 0.16);
  opacity: 1 !important;
  z-index: ${({ theme }) => `${theme.zIndex.generalTooltip} !important`};
  text-transform: none !important;
`;
